import type { SettingsTranslation } from "./index";

export const german = {
  section_appearance: "Darstellung & Sprache",
  section_notifications: "Benachrichtigungen",
  section_privacy: "Datenschutz",
  section_security: "Sicherheit",
  saving: "Wird gespeichert...",
  saved: "Gespeichert",
  auto_analyze_recordings: "Sitzungen automatisch analysieren",
  auto_analyze_recordings_help:
    "Analysiert jede Sitzung, sobald sie hochgeladen ist, bei aktiviertem Vor dem Hochladen prüfen also direkt nach Ihrer Freigabe. Wenn deaktiviert, bleiben Sitzungen nicht analysiert, bis Sie die Analyse starten.",
  recording_screenshot_format: "Komprimierung",
  recording_screenshot_format_help:
    "Komprimierte Screenshots verursachen weniger Netzwerkverkehr und synchronisieren schneller, beanspruchen während der Aufnahme aber die CPU. Ausschalten, um die Leistung zu optimieren.",
  screenshot_format_load_failed: "Komprimierungseinstellung konnte nicht geladen werden",
  screenshot_format_update_failed: "Komprimierungseinstellung konnte nicht aktualisiert werden",
  recording_screenshot_blacklist: "Ausgeschlossene Apps",
  recording_screenshot_blacklist_help:
    "Solange eine dieser Apps im Vordergrund ist, wird nichts aufgezeichnet.",
  screenshot_blacklist_load_failed: "Ausgeschlossene Apps konnten nicht geladen werden",
  screenshot_blacklist_update_failed: "Ausgeschlossene Apps konnten nicht aktualisiert werden",
  screenshot_blacklist_app_placeholder: "App-Name",
  screenshot_blacklist_add: "Hinzufügen",
  screenshot_blacklist_empty: "Keine Apps ausgeschlossen.",
  screenshot_blacklist_remove: "{{app}} entfernen",
  recording_screenshot_redaction: "Schwärzung sensibler Texte",
  recording_screenshot_redaction_help:
    "In Screenshots erkannte sensible Texte (E-Mail-Adressen, Kartennummern, Zugangsdaten …) werden vor dem Speichern geschwärzt. Die Erkennung ist nicht lückenlos; gilt ab dem nächsten Aufnahmestart.",
  screenshot_redaction_load_failed:
    "Einstellung zur Schwärzung sensibler Texte konnte nicht geladen werden",
  redaction_categories: "Was geschwärzt wird",
  redaction_category_enabled: "Aktiv",
  redaction_category_experimental: "Experimentelle einbeziehen",
  redaction_experimental_help:
    "Experimentelle Erkennungen erfassen mehr sensiblen Text, sind aber weniger präzise und können auch harmlose Inhalte schwärzen.",
  redaction_category_credentials: "Zugangsdaten & Geheimnisse",
  redaction_category_accounts: "Karten & Bankkonten",
  redaction_category_financial: "Finanzbeträge",
  redaction_category_personal: "Persönliche Identität",
  redaction_category_contact: "Kontaktdaten",
  redaction_category_network: "Netzwerkadressen",
  redaction_category_organizations: "Organisationen",
  redaction_category_suspicious: "Verdächtig aussehender Text",
  redaction_category_help: {
    credentials:
      "Passwörter, API-Schlüssel, Zugriffstokens und andere Geheimnisse, die Zugang zu Konten und Systemen gewähren.",
    accounts: "Kreditkartennummern, IBANs und andere Zahlungs- und Bankkontodaten.",
    financial: "Gehälter, Vergütungen und andere Finanzbeträge.",
    personal: "Ausweisnummern, Steuernummern, Geburtsdaten und Personennamen.",
    contact: "E-Mail-Adressen, Telefonnummern und Postadressen.",
    network: "IP-Adressen und andere Netzwerkkennungen.",
    organizations: "Namen von Firmen und anderen Organisationen.",
    suspicious:
      "Text ohne bestimmte Kategorie, der dennoch sensibel wirkt, etwa lange Ziffernfolgen.",
  },
  notification_frequency: "E-Mail-Frequenz",
  notification_frequency_help:
    "Wie oft Alert-E-Mails höchstens gesendet werden. Zurückgehaltene Ergebnisse kommen in die nächste E-Mail.",
  notification_frequency_immediately: "Sofort",
  notification_frequency_daily: "Höchstens täglich",
  notification_frequency_weekly: "Höchstens wöchentlich",
  notification_frequency_monthly: "Höchstens monatlich",
  notification_channel: "Alert-Zustellung",
  notification_channel_help:
    "Wo Alert-Ergebnisse ankommen. In-App kommt sofort an; E-Mails folgen der Frequenz unten.",
  notification_channel_help_saas:
    "Wo Alert-Ergebnisse ankommen. In-App braucht die Desktop-App — im Browser erscheinen Ergebnisse nur in der Watchlist. E-Mails folgen der Frequenz unten.",
  notification_channel_in_app_warning:
    "In-App-Benachrichtigungen kommen nur an, solange die App geöffnet ist. Ohne E-Mail warten Ergebnisse aus deiner Abwesenheit still in der Watchlist.",
  notification_channel_in_app_saas_warning:
    "In-App-Benachrichtigungen brauchen die Desktop-App, nicht den Browser. Füge E-Mail hinzu, um hier benachrichtigt zu werden.",
  notification_settings_load_failed: "Benachrichtigungseinstellungen konnten nicht geladen werden",
  notification_settings_update_failed:
    "Benachrichtigungseinstellungen konnten nicht aktualisiert werden",
  change_password: "Passwort ändern",
  change_password_help:
    "Verwende dein aktuelles Passwort, um ein neues Passwort für dieses Konto festzulegen.",
  current_password: "Aktuelles Passwort",
  new_password: "Neues Passwort",
  change_password_saved: "Passwort aktualisiert.",
  change_password_failed: "Passwort konnte nicht geändert werden",
  mfa: "Zwei-Faktor-Authentifizierung",
  mfa_enabled: "Aktiviert",
  mfa_disabled: "Deaktiviert",
  mfa_enabled_help: "Die Passwort-Anmeldung benötigt einen Code aus deiner Authenticator-App.",
  mfa_disabled_help:
    "Füge der Passwort-Anmeldung mit einer Authenticator-App einen zweiten Schritt hinzu.",
  mfa_enable: "2FA aktivieren",
  mfa_disable: "2FA deaktivieren",
  mfa_enroll_help:
    "Füge dieses Geheimnis deiner Authenticator-App hinzu und gib dann den erzeugten 6-stelligen Code ein.",
  mfa_disable_help:
    "Gib einen aktuellen Authenticator-Code ein, um die Zwei-Faktor-Authentifizierung zu deaktivieren.",
  mfa_code: "Authenticator-Code",
  mfa_qr_code: "Scanne diesen QR-Code mit deiner Authenticator-App",
  mfa_confirm: "Code bestätigen",
  mfa_copy_secret: "Geheimnis kopieren",
  mfa_open_authenticator: "In Authenticator-App öffnen",
  mfa_load_failed: "2FA-Status konnte nicht geladen werden",
  mfa_start_failed: "2FA-Einrichtung konnte nicht gestartet werden",
  mfa_confirm_failed: "Zwei-Faktor-Authentifizierung konnte nicht aktiviert werden",
  mfa_disable_failed: "Zwei-Faktor-Authentifizierung konnte nicht deaktiviert werden",
  theme: "Darstellung",
  theme_light: "Hell",
  theme_dark: "Dunkel",
  toggle_on: "Ein",
  toggle_off: "Aus",
  recording_review_before_upload: "Vor dem Hochladen prüfen",
  recording_review_before_upload_help:
    "Jede abgeschlossene Sitzung bleibt auf diesem Computer, bis Sie sie freigeben oder löschen. Wenn deaktiviert, werden Sitzungen hochgeladen, sobald sie abgeschlossen sind.",
  recording_review_load_failed:
    "Einstellung zum Prüfen vor dem Hochladen konnte nicht geladen werden",
  pending_review_title: "Sitzungen, die auf Ihre Prüfung warten",
  pending_review_message:
    "{{count}} Sitzungen warten noch auf Ihre Prüfung. Jetzt hochladen oder zur Prüfung behalten?",
  pending_review_message_one:
    "{{count}} Sitzung wartet noch auf Ihre Prüfung. Jetzt hochladen oder zur Prüfung behalten?",
  pending_review_upload: "Jetzt hochladen",
  pending_review_keep: "Zur Prüfung behalten",
  pending_review_upload_failed: "Hochladen der Sitzungen, die auf Prüfung warten, fehlgeschlagen",
} satisfies SettingsTranslation;
